var map = {
	"./icon-Twitter-black.png": "608c",
	"./icon-Twitter.png": "324b",
	"./icon-arrow-down-black.png": "9f65",
	"./icon-arrow-left-black.png": "3775",
	"./icon-arrow-right-black.png": "6b21",
	"./icon-arrow-right-double.png": "e5f7",
	"./icon-arrow-right.png": "d1ae",
	"./icon-auctioneer.png": "321a",
	"./icon-audio-off.png": "8d94",
	"./icon-audio-on.png": "8dcd",
	"./icon-audio-stop.png": "6b17",
	"./icon-back.png": "3f93",
	"./icon-close.png": "9304",
	"./icon-collect-black.png": "d926",
	"./icon-collect-red.png": "225c",
	"./icon-collect.png": "07a4",
	"./icon-collected-red.png": "67a0",
	"./icon-collected.png": "6c4b",
	"./icon-deal-empty.png": "3d97",
	"./icon-expand.png": "e86e",
	"./icon-facebook-black.png": "2b7d",
	"./icon-facebook.png": "784c",
	"./icon-filter.png": "64db",
	"./icon-follow-empty.png": "fc7e",
	"./icon-full-screen-off.png": "a743",
	"./icon-full-screen-on.png": "5772",
	"./icon-guide-video.png": "b92e",
	"./icon-heart.png": "8211",
	"./icon-instagram-black.png": "f1e9",
	"./icon-instagram.png": "e5e5",
	"./icon-line-black.png": "ca6e",
	"./icon-line.png": "0599",
	"./icon-live-audio.png": "0397",
	"./icon-live-notice.png": "48b4",
	"./icon-live-player.png": "063f",
	"./icon-live-trigger.png": "0e44",
	"./icon-live.png": "b8bb",
	"./icon-login.png": "7249",
	"./icon-logo-black.png": "b714",
	"./icon-logo.png": "8a90",
	"./icon-menu.png": "0e8e",
	"./icon-message.png": "4fff",
	"./icon-notice.png": "ce46",
	"./icon-order-cancelled.png": "5b24",
	"./icon-order-completed.png": "dddc",
	"./icon-order-wait-pay.png": "0fa3",
	"./icon-order-wait-receive.png": "f30d",
	"./icon-order-wait-send.png": "fa69",
	"./icon-pdf.png": "fd06",
	"./icon-play-shadow.png": "caa4",
	"./icon-search-white.png": "e016",
	"./icon-search.png": "35f2",
	"./icon-select-empty.png": "508e",
	"./icon-share-black.png": "a013",
	"./icon-share.png": "89fb",
	"./icon-shrink.png": "7bf3",
	"./icon-sort-grey.png": "cd6a",
	"./icon-switch-left.png": "5ec3",
	"./icon-switch-right.png": "4877",
	"./icon-tangle-down.png": "85f8",
	"./icon-tangle-down2.png": "2e6e",
	"./icon-tangle-right.png": "8d50",
	"./icon-upload-file.png": "352b",
	"./icon-video-off.png": "d99e",
	"./icon-video-on.png": "e490",
	"./icon-watch.png": "ae81",
	"./icon-weixin-black.png": "5ab6",
	"./icon-weixin.png": "b9b2",
	"./icon-xiaohongshu-black.png": "a54d",
	"./icon-xiaohongshu.png": "4d2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "07a0";